import escudo from "@/assets/escudo.svg";

export default function EscudoBadge({ className = "h-10 w-10" }) {
  return (
    <img
      src={escudo}
      alt="Escudo Nacional del Perú"
      className={className}
      width={40}
      height={40}
      draggable={false}
    />
  );
}
